import Typography from "typography";
import wordpress2013 from "typography-theme-wordpress-2013";

wordpress2013.headerLineHeight = 1.1;
wordpress2013.googleFonts = [];
wordpress2013.overrideThemeStyles = () => {
  const fontFamily = "Roboto Slab";
  const fontFamilyBody =
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif';
  return {
    a: {
      color: `rgb(60,99,243)`
    },
    html: { fontFamily: fontFamilyBody },
    body: { fontFamily: fontFamilyBody },
    h1: { fontFamily, lineHeight: 1 },
    h2: { fontFamily, fontSize: "1.2rem" },
    h3: { fontFamily, fontSize: "1.1rem" },
    h4: { fontFamily, fontSize: "1rem" },
    h5: { fontFamily, fontSize: "1rem" },
    h6: { fontFamily, fontSize: "1rem" }
  };
};

const typography = new Typography(wordpress2013);
const { rhythm, scale } = typography;

const containerStyle = {
  maxWidth: 700,
  margin: `0 auto`,
  // padding: rhythm(2 / 4),
  "@media screen and (min-width: 768px)": {
    padding: rhythm(3 / 4)
  }
};

export { rhythm, scale, containerStyle };
export default typography;
